export default "__VITE_ASSET__BJZin0Co__"